export default __webpack_public_path__ + "static/media/GreyArrowDown.dfdbf0f0.svg";